import { apiClient } from '@/lib/api/client'
import type {
  CreateFeatureFlagDto,
  UpdateFeatureFlagDto,
  FeatureFlagResponseDto,
  ResolvedFlagsResponseDto,
} from '@fp3/shared'

export const featureFlagsApi = {
  resolve: async (): Promise<ResolvedFlagsResponseDto> => {
    const { data } = await apiClient.get<ResolvedFlagsResponseDto>('/feature-flags/resolve')
    return data
  },

  getAll: async (): Promise<FeatureFlagResponseDto[]> => {
    const { data } = await apiClient.get<FeatureFlagResponseDto[]>('/feature-flags')
    return data
  },

  create: async (dto: CreateFeatureFlagDto): Promise<FeatureFlagResponseDto> => {
    const { data } = await apiClient.post<FeatureFlagResponseDto>('/feature-flags', dto)
    return data
  },

  update: async (id: string, dto: UpdateFeatureFlagDto): Promise<FeatureFlagResponseDto> => {
    const { data } = await apiClient.patch<FeatureFlagResponseDto>(`/feature-flags/${id}`, dto)
    return data
  },

  delete: async (id: string): Promise<void> => {
    await apiClient.delete(`/feature-flags/${id}`)
  },
}
